/**
 * Sa.Reseller.Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type OfferOrderTemplateEnum = 'Classic' | 'StandardHtml' | 'StandardLayout';

export const OfferOrderTemplateEnum = {
    Classic: 'Classic' as OfferOrderTemplateEnum,
    StandardHtml: 'StandardHtml' as OfferOrderTemplateEnum,
    StandardLayout: 'StandardLayout' as OfferOrderTemplateEnum
};

